import './public'
import { App } from './app'
import React from 'react'
import ReactDOM from 'react-dom'

// harmless browser/MUI timing quirk (resize callback fires after the observer's frame budget) —
// stop CRA's dev error overlay from hijacking the screen for it without swallowing real errors
const isBenignResizeObserverError = (message: unknown) =>
  typeof message === 'string' &&
  message.includes('ResizeObserver loop completed with undelivered notifications')

window.addEventListener('error', e => {
  if (isBenignResizeObserverError(e.message)) {
    e.stopImmediatePropagation()
  }
})

ReactDOM.render(<App />, document.getElementById('root'))
